import React, { FC, PropsWithChildren } from "react";
import { AbilityProvider as CaslAbilityProvider } from "@casl/react";

import { Ability } from "../../models/permissions";
import abilityService from "../../services/ability";

type AbilityProviderProps = {
  value?: Ability;
};

export const AbilityProvider: FC<PropsWithChildren<AbilityProviderProps>> = ({
  value,
  children,
}) => {
  const ability = value || abilityService.getAbility();

  return <CaslAbilityProvider value={ability}>{children}</CaslAbilityProvider>;
};
